import React from "react";
import { TimeArticles_Fr } from "./ConstantsArticles";

function MainCalculatorsList() {
  const calculatorsList = TimeArticles_Fr;
  const calculatorName = "Articles sur le temps et les dates";
  return (
    <div>
      <div
        className="bg-success text-white text-center"
        style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <b>{calculatorName}</b>
      </div>
      <div className="border border-light">
        <ul>
          {calculatorsList.map(
            (item, index) =>
              (
                <li key={index}>
                  <a href={item.link} className="item-link">
                    {item.name}
                  </a>
                </li>
              )
          )}
        </ul>
      </div>
    </div>
  );
}

export default MainCalculatorsList;
